import {
    checkActionPermission,
    checkPermission,
} from "../../core/routes/RouteValidator";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {InventoryService} from "./Service";
import {useSelector} from "react-redux";
import $ from "jquery";
import {toast} from "react-hot-toast";
import XConstants from "../../core/config/Constants";
import {useEffect} from "react";

const InventoryManagement = () => {
    const service = new InventoryService();
    const navigate = useNavigate();
    const location = useLocation();
    const user = useSelector((state: any) => state.auth);
    const company = useSelector((state: any) => state.company);

    const getItems = () => {
        try {
            $("#items").DataTable().destroy();
        } catch (e) {
            console.log(e);
        }
        let token = localStorage.getItem("token");
        $("#items").DataTable({
            lengthMenu: [10, 20, 50, 100, 500, 1000],
            pageLength: 100,
            processing: true,
            serverSide: true,
            columnDefs: [
                {
                    render: function (data: any, type: any, row: string[]) {
                        return `<input type="number" class="form-control" value="${data}" />`;
                    },
                    createdCell: (
                        td: any,
                        cellData: any,
                        rowData: any,
                        row: any,
                        col: any
                    ) => {

                        $(td).find('input').on('change', async (event: any) => {
                            const newValue = event.target.value;
                            console.log(`New value for row ${row} is ${newValue}`);
                            const res = await service.update(rowData[0], {
                                quantity: parseInt(newValue),
                            });
                            if (res) {
                                toast.success("Quantity updated successfully", {});
                            }
                        });

                    },
                    targets: 3,
                },

            ],
            ajax: {
                url: `${XConstants.baseUrl}/company/inventory/list`,
                type: "POST",
                contentType: "application/json",
                headers: {
                    Authorization: token,
                },
                data: function (d: any) {
                    return JSON.stringify({
                        ...d,
                    });
                },
            },
        });
    };

    useEffect(() => {
        getItems();
    }, []);


    return (
        <>
            <div className="page-header">
                <div className="content-page-header">
                    <h5>Inventory</h5>
                </div>
            </div>
            <div className="row">
                <div className="card col-12">
                    <div className="card-body w-100">
                        <div className="table-responsive w-100">
                            <table id="items" className="table datatable  w-100">
                                <thead>
                                <tr>
                                    <th>Id</th>
                                    <th>Product</th>
                                    <th>Variant</th>
                                    <th>Quantity</th>
                                </tr>
                                </thead>
                                <tbody></tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default InventoryManagement;
